import { DEFAULT_REQUIRED_EXPORT_FIELDS } from '../utils/csv';

// Neutral system defaults — used to fill missing keys in a tenant's Supabase config.
// These are intentionally empty/generic. No brand-specific values belong here.
// Each tenant's real config lives in the `tenants` table in Supabase.
export const SYSTEM_DEFAULTS = {
  territories:      [],
  translationLangs: [],
  departments:      [],
  productTypes:     [],
  quickTags:        [],
  badges:           [],
  calCategories:    [],
  sizeCategories:   [],
  careTemplate:     '',
  fitTemplate:      '',
  metafields:       [],
  // Quick-insert description templates (Creative tab's template buttons). Neutral, product-agnostic
  // starters — tenants replace these in Settings → Description Templates with copy that fits what
  // they sell.
  descriptionTemplates: [
    { id: 'single', label: 'Single product', body: '<p>Meet the [Product Name] in [Colour], designed for everyday quality.</p>\n<ul>\n  <li>Feature one</li>\n  <li>Feature two</li>\n</ul>' },
    { id: 'set',    label: 'Set / bundle',   body: '<p>The [Product Name] in [Colour], everything you need in one coordinated set.</p>\n<ul>\n  <li>Includes: [item 1], [item 2]</li>\n  <li>Feature two</li>\n  <li>Feature three</li>\n</ul>' },
  ],
  variantPresets: [],
  // Studio crop tool presets (Settings → Crop Presets). Ratio-only starters, no fixed output
  // size — tenants add their own (e.g. "PDP 4:5 at 2000px") to match their storefront.
  cropPresets: [
    { id: 'square',    label: 'Square',    ratioW: 1,  ratioH: 1,  width: '' },
    { id: 'portrait',  label: 'Portrait',  ratioW: 4,  ratioH: 5,  width: '' },
    { id: 'landscape', label: 'Landscape', ratioW: 16, ratioH: 9,  width: '' },
    { id: 'vertical',  label: 'Vertical',  ratioW: 9,  ratioH: 16, width: '' },
  ],
  // Product-family grouping (Dashboard "colour groups" / Springboard "Group by style"). Default
  // preserves the app's original behaviour — group by the built-in titleNoColour field — so
  // existing tenants see no change until they explicitly reconfigure this in Settings.
  groupingField:    'titleNoColour',
  groupingLabel:    'colour',
  // Overrides for the Shopify metafield key each built-in field exports/imports under (bare key,
  // or a full "namespace.key"; the default namespace is config.metafieldNamespace, else the
  // subdomain). Unset entries fall back to the field definitions — see FIELD_MAPPING_DEFAULTS.
  fieldMappings:    {},
  // Which fields must be filled before a product can export — default matches the app's
  // original QA checklist so existing tenants see no change until they remove fields they
  // don't track (e.g. a tenant with no Fit & Fabric/Care Instructions workflow at all).
  exportRequiredFields: DEFAULT_REQUIRED_EXPORT_FIELDS,
  branding: {
    appName:      '',
    primaryColor: '',
    primaryFg:    '',
    logoUrl:      '',
    displayFont:  '',
  },
};

export const FONT_OPTIONS = [
  { value: '',        label: 'Serif (default)', stack: 'Georgia, serif' },
  { value: 'Georgia', label: 'Georgia',          stack: 'Georgia, serif' },
  { value: 'Inter',   label: 'Inter',            stack: '"Inter", -apple-system, sans-serif' },
];
